
<template>
	<i>
		<svg width='24' height='24' viewBox='0 0 24 24' fill='none'><path d='M21.3601 6.28L21.3001 6.22C20.9101 5.83 20.2701 5.85 19.9101 6.26L17.7301 8.71C15.6801 6.4 12.8301 5 9.61009 5C7.11009 5 4.78009 5.87 2.86009 7.3C2.39009 7.65 2.34009 8.34 2.75009 8.75L2.81009 8.81C3.14009 9.14 3.67009 9.2 4.04009 8.92C5.63009 7.72 7.54009 7 9.61009 7C12.3501 7 14.7001 8.26 16.3801 10.24L13.5001 13.48L10.2101 10.19C9.82009 9.8 9.19009 9.8 8.80009 10.19L2.68009 16.32C2.31009 16.69 2.31009 17.3 2.68009 17.67L2.83009 17.82C3.20009 18.19 3.81009 18.19 4.18009 17.82L9.50009 12.49L12.7501 15.74C13.1601 16.15 13.8201 16.13 14.2001 15.7L17.5501 11.94C18.1701 13.06 18.6301 14.33 18.8701 15.67C18.9501 16.14 19.3401 16.49 19.8201 16.49H19.9101C20.5101 16.49 20.9601 15.94 20.8501 15.35C20.5301 13.5 19.8701 11.81 18.9601 10.35L21.4001 7.6C21.7401 7.22 21.7201 6.64 21.3601 6.28Z' fill='#323232'/></svg>
	</i>
</template>

<script>
export default {
	name: `b-new-b-icon-multiline-chart`,
	components: {},
	computed: {},
	props: {
		spin: {
			type: Boolean,
			default: false
		}
	},
	mounted() {
		if(this.spin){
			this.$nextTick(() => this.$el.classList.add('spin'));
		}
	}
};
</script>

<style scoped lang="scss">
i {
	display: inline-block;
	vertical-align: middle;

	svg {
		width: 1em;
		height: auto;
		display: block;
	}

	*:not([fill='none']) {
		fill: currentColor;
	}
}

path.a {
	fill: none;
}

.spin {
	animation: rotation 2s infinite linear;
}

@keyframes rotation {
	from {
		transform: rotate(0deg);
	}
	to {
		transform: rotate(359deg);
	}
}
</style>

<docs>
    IconMultilineChart

    ```js
    <b-new-b-icon-multiline-chart />
    ```
</docs>


